import styled from "styled-components";
export const Small = styled.small`
  font-size: 12px;
  line-height: 16px;
  font-weight: 300;
  ${props => props.theme.fonts.default}
`;